import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ToolCard = ({ tool, onRequestAccess }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'connected':
        return 'text-success';
      case 'pending':
        return 'text-warning';
      case 'unavailable':
        return 'text-muted-foreground';
      default:
        return 'text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'connected':
        return 'CheckCircle2';
      case 'pending':
        return 'Clock';
      case 'unavailable':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'connected':
        return 'Connected';
      case 'pending':
        return 'Pending';
      case 'unavailable':
        return 'Not Available';
      default:
        return 'Unknown';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-all duration-200 hover:border-primary/30">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-muted/30 rounded-lg flex items-center justify-center">
            <Icon name={tool?.icon} size={24} color="var(--color-primary)" strokeWidth={2} />
          </div>
          <div>
            <h3 className="font-semibold text-foreground text-lg">{tool?.name}</h3>
            <div className={`flex items-center gap-1 text-sm ${getStatusColor(tool?.status)}`}>
              <Icon name={getStatusIcon(tool?.status)} size={14} color="currentColor" />
              <span>{getStatusText(tool?.status)}</span>
            </div>
          </div>
        </div>
        {tool?.ssoEnabled && (
          <div className="flex items-center gap-1 px-2 py-1 bg-primary/10 rounded text-xs text-primary font-medium">
            <Icon name="Shield" size={12} color="var(--color-primary)" />
            SSO
          </div>
        )}
      </div>
      <p className="text-muted-foreground text-sm mb-4 line-clamp-2">{tool?.description}</p>
      <div className="flex items-center gap-2 mb-4">
        {tool?.tags?.map((tag, index) => (
          <span
            key={index}
            className="px-2 py-1 bg-muted/30 rounded text-xs text-muted-foreground"
          >
            {tag}
          </span>
        ))}
      </div>
      <div className="flex items-center gap-2">
        {tool?.status === 'connected' ? (
          <Button variant="outline" size="sm" fullWidth iconName="ExternalLink" iconPosition="right">
            Open Tool
          </Button>
        ) : (
          <Button
            variant="default"
            size="sm"
            fullWidth
            iconName="Plus"
            iconPosition="left"
            onClick={() => onRequestAccess(tool)}
          >
            Request Access
          </Button>
        )}
        {tool?.hasGuide && (
          <Button variant="ghost" size="icon">
            <Icon name="BookOpen" size={18} color="var(--color-muted-foreground)" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default ToolCard;